
export enum DeleteStatus {
    Undeleted,
    Deleting,
    Deleted,
    Error,
}